import React from "react";
var __jsx = React.createElement;
import { useRef } from "react";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { faClock, faUserDoctor, faPrint, faCopy, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useReactToPrint } from "react-to-print";
import AwesomeIcon from "../AwesomeIcon";
import Modal from "../common/Modal";
import { useTranslation } from "react-i18next";
import Toast from "../Toast";
import copy from "copy-to-clipboard";
var MedicalReportModal = function MedicalReportModal(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    reportName = _ref.reportName,
    reportContent = _ref.reportContent,
    contentType = _ref.contentType,
    encounterDate = _ref.encounterDate,
    provider = _ref.provider,
    location = _ref.location;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var printRef = useRef(null);
  var printFn = useReactToPrint({
    contentRef: printRef,
    preserveAfterPrint: true,
    documentTitle: reportName || "Medical Report"
  });
  var onPrint = function onPrint() {
    trackEvent(MIXPANEL_EVENTS.MEDICAL_REPORT_PRINTED, {
      label: reportName
    });
    printFn();
  };
  var _onCopy = function onCopy() {
    trackEvent(MIXPANEL_EVENTS.MEDICAL_REPORT_COPIED, {
      label: reportName
    });
    var textContent;
    if (contentType === "text/html") {
      // For HTML, create a temporary div to decode HTML entities
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = reportContent;
      textContent = tempDiv.textContent || tempDiv.innerText || "";
    } else {
      // For XML and other text content, use the content directly
      textContent = reportContent;
    }
    copy(textContent, {
      format: "text/plain",
      onCopy: function onCopy() {
        Toast.success(t("report_copied_to_clipboard") || "Report copied to clipboard");
      }
    });
  };
  var formatDate = function formatDate(dateStr) {
    if (!dateStr) return "";
    var date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onClose: onClose,
    closeOnClickAway: true,
    bgOpacity: true,
    className: "flex flex-col w-11/12 sm:w-10/12 lg:w-8/12 xl:w-6/12 max-h-[85vh] medical-report-modal",
    closeButton: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden rounded-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-teal-600 dark:bg-teal-700 text-white px-6 py-4 rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between w-full gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-col min-w-0 text-left"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-lg font-semibold mb-2 truncate"
  }, reportName), location && /*#__PURE__*/React.createElement("p", {
    className: "text-sm mt-1 opacity-90 truncate"
  }, location)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-6 flex-shrink-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row gap-4 text-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUserDoctor
  }), /*#__PURE__*/React.createElement("span", null, provider || "N/A")), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faClock
  }), /*#__PURE__*/React.createElement("span", null, formatDate(encounterDate)))), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "p-2 hover:bg-teal-700 dark:hover:bg-teal-600 rounded-full transition-colors",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "2x"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 overflow-y-auto bg-white dark:bg-gray-900"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-6"
  }, contentType === "text/html" ? /*#__PURE__*/React.createElement("div", {
    className: "font-mono text-[13px] leading-relaxed whitespace-pre-wrap break-words text-gray-900 dark:text-white dark:[&_*]:!text-white overflow-x-auto",
    dangerouslySetInnerHTML: {
      __html: reportContent
    }
  }) : contentType === "text/xml" || contentType === "application/xml" || contentType.startsWith("text/") ? /*#__PURE__*/React.createElement("div", {
    className: "font-mono text-[13px] leading-relaxed whitespace-pre-wrap break-words text-gray-900 dark:text-gray-100 overflow-x-auto"
  }, reportContent) : contentType === "application/pdf" ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center w-full h-full min-h-[500px]"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: reportContent,
    title: reportName,
    className: "w-full h-full min-h-[500px] rounded-lg shadow-lg border border-gray-300 dark:border-gray-700",
    style: {
      maxHeight: "70vh"
    }
  })) : contentType.startsWith("image/") ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: reportContent,
    alt: reportName,
    className: "max-w-full h-auto rounded-lg shadow-lg",
    style: {
      maxHeight: "70vh"
    }
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center w-full h-full min-h-[500px]"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: reportContent,
    title: reportName,
    className: "w-full h-full min-h-[500px] rounded-lg shadow-lg border border-gray-300 dark:border-gray-700",
    style: {
      maxHeight: "70vh"
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-5 px-6 py-4 bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 rounded-b-lg"
  }, contentType !== "application/pdf" && contentType !== "image/png" && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onPrint,
    className: "flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-300 hover:text-teal-600 dark:hover:text-teal-400 transition-colors",
    title: "Print"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPrint,
    size: "lg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-sm"
  }, "Print")), /*#__PURE__*/React.createElement("button", {
    onClick: _onCopy,
    className: "flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-300 hover:text-teal-600 dark:hover:text-teal-400 transition-colors",
    title: "Copy to clipboard"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCopy,
    size: "lg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-sm"
  }, "Copy")))))), /*#__PURE__*/React.createElement("div", {
    className: "h-0 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-black m-8 gap-6",
    ref: printRef
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: "text-xl font-bold mb-4"
  }, reportName), /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-600 mb-2"
  }, /*#__PURE__*/React.createElement("strong", null, "Provider:"), " ", provider), /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-600 mb-2"
  }, /*#__PURE__*/React.createElement("strong", null, "Date:"), " ", formatDate(encounterDate)), location && /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-600 mb-4"
  }, /*#__PURE__*/React.createElement("strong", null, "Location:"), " ", location)), contentType === "text/html" ? /*#__PURE__*/React.createElement("div", {
    className: "font-mono text-[13px] leading-relaxed whitespace-pre-wrap break-words",
    dangerouslySetInnerHTML: {
      __html: reportContent
    }
  }) : contentType === "text/xml" || contentType === "application/xml" || contentType.startsWith("text/") ? /*#__PURE__*/React.createElement("div", {
    className: "font-mono text-[13px] leading-relaxed whitespace-pre-wrap break-words"
  }, reportContent) : /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-600"
  }, /*#__PURE__*/React.createElement("p", null, "This content type (", contentType, ") cannot be printed directly."), /*#__PURE__*/React.createElement("p", null, "Please use the browser's print dialog on the main view.")))));
};
export default MedicalReportModal;